import {
  AddProjectTechnologyRequest,
  AddWorkExperienceTechnologyRequest,
  Technology,
  TechnologyDictionaryModel,
} from "../models/technology.model";
import { BackendHttpService } from "./backendHttpService";
import { technologyDictionaryService } from "./dictionaries";

export class TechnologyService extends BackendHttpService {
  constructor() {
    super("technology");
  }

  // Dictionary methods - delegated to dictionary service
  async getTechnologiesDictionary(): Promise<TechnologyDictionaryModel[]> {
    return technologyDictionaryService.getTechnologiesDictionary();
  }

  // Project technology methods
  async addTechnologyToProject(
    request: AddProjectTechnologyRequest
  ): Promise<void> {
    try {
      await this.post<AddProjectTechnologyRequest, void>(request, "/project");
    } catch (error) {
      console.error("Error adding technology to project:", error);
      throw error;
    }
  }

  async deleteTechnologyFromProject(
    projectId: number,
    technologyId: number
  ): Promise<void> {
    try {
      await this.delete(`/project/${projectId}/${technologyId}`);
    } catch (error) {
      console.error("Error deleting technology from project:", error);
      throw error;
    }
  }

  // Work experience technology methods
  async addTechnologyToWorkExperience(
    request: AddWorkExperienceTechnologyRequest
  ): Promise<void> {
    try {
      await this.post<AddWorkExperienceTechnologyRequest, void>(
        request,
        "/workexperience"
      );
    } catch (error) {
      console.error("Error adding technology to work experience:", error);
      throw error;
    }
  }

  async deleteTechnologyFromWorkExperience(
    workExperienceId: number,
    technologyId: number
  ): Promise<void> {
    try {
      await this.delete(`/workexperience/${workExperienceId}/${technologyId}`);
    } catch (error) {
      console.error("Error deleting technology from work experience:", error);
      throw error;
    }
  }

  // Favourite methods
  async markTechnologiesAsNotFavourite(technology: Technology): Promise<void> {
    try {
      await this.put<Technology, void>(technology, "favourite");
    } catch (error) {
      console.error("Error marking technology as not favourite:", error);
      throw error;
    }
  }
}
